import React, { useState, useRef } from 'react';
import './sub1.css';
// import Contact from './Contact';
import { Helmet } from 'react-helmet';
import babysitting from '../../images/babysitting.jpeg'
import emailjs from "@emailjs/browser";
import contactConfig from '../../confi';

export default function BabySitting() {
  const [formData, setFormData] = useState({
    parentName: '',
    email: '',
    phone: '',
    childAge: '',
    serviceDate: '',
    serviceTime: '',
    specialRequirements: '',
    address: '',
    duration: ''
  });
  const form = useRef();
  const [loading, setLoading] = useState(false);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Booking request submitted successfully! We will contact you soon.');
    // Reset form
    setFormData({
      parentName: '',
      email: '',
      phone: '',
      childAge: '',
      serviceDate: '',
      serviceTime: '',
      specialRequirements: '',
      address: '',
      duration: ''
    });
  };

  const babySittingFeatures = [
    {
      icon: '🍼',
      title: 'Infant & Toddler Care',
      description: 'Expert feeding and care for infants and toddlers with proper hygiene'
    },
    {
      icon: '🎓',
      title: 'Trained & Verified',
      description: 'Background verified babysitters with police verification and references'
    },
    {
      icon: '🎮',
      title: 'Engaging Activities',
      description: 'Fun educational activities and playtime to keep children engaged and happy'
    },
    {
      icon: '⏰',
      title: 'Flexible Scheduling',
      description: 'Hourly, daily, or monthly services as per your convenience'
    },
    {
      icon: '📚',
      title: 'Homework Assistance',
      description: 'Help with homework and study routines for older children'
    },
    {
      icon: '🆘',
      title: 'Emergency Prepared',
      description: 'Trained in basic first aid and emergency response procedures'
    }
  ];

  const serviceFeatures = [
    {
      icon: "🍼",
      text: "Feed and care for infants and toddlers"
    },
    {
      icon: "✨",
      text: "Maintain hygiene and cleanliness"
    },
    {
      icon: "🎮",
      text: "Play and engage through fun activities"
    },
    {
      icon: "📚",
      text: "Help with homework and study routines"
    },
    {
      icon: "😴",
      text: "Put children to sleep safely and on time"
    },
    {
      icon: "🆘",
      text: "Handle emergency situations responsibly"
    }
  ];

  const whyChooseUs = [
    {
      title: "Background Verified",
      description: "Every babysitter is identity-checked, police-verified, and reference-approved.",
      icon: "✅"
    },
    {
      title: "Trained in Childcare",
      description: "Orientation and training to handle infants, toddlers, and young children responsibly.",
      icon: "🎓"
    },
    {
      title: "Patient & Caring",
      description: "Compassionate, soft-spoken, and attentive approach to childcare.",
      icon: "💖"
    },
    {
      title: "Flexible Scheduling",
      description: "Services available on hourly, daily, or monthly basis as per your convenience.",
      icon: "⏰"
    }
  ];

  const processSteps = [
    {
      step: "1",
      title: "Share Your Requirement",
      description: "Let us know your child's age, routine, and the kind of help you need"
    },
    {
      step: "2",
      title: "Get Shortlisted Profiles",
      description: "We'll send you verified and trained babysitter profiles matching your preferences"
    },
    {
      step: "3",
      title: "Interview & Select",
      description: "Personally meet and choose the babysitter you feel most comfortable with"
    },
    {
      step: "4",
      title: "Begin Services",
      description: "Your chosen babysitter joins as per your schedule and timing"
    },
    {
      step: "5",
      title: "Ongoing Support",
      description: "Regular follow-ups and replacements if required for complete satisfaction"
    }
  ];

  const testimonials = [
    {
      name: "Mrs. Aarti Patel",
      location: "Satellite, Ahmedabad",
      rating: "⭐⭐⭐⭐⭐",
      text: "I was nervous about leaving my 6-month-old with anyone, but J P Home Services found us a gentle and caring babysitter who feels like part of our family now."
    },
    {
      name: "Mr. & Mrs. Mehta",
      location: "Surat",
      rating: "⭐⭐⭐⭐⭐",
      text: "As working parents, we needed someone reliable. The babysitter from J P Home Services is punctual, responsible, and loves our daughter like her own."
    },
    {
      name: "Dr. Niyati Shah",
      location: "Vadodara",
      rating: "⭐⭐⭐⭐⭐",
      text: "They provided us with a babysitter who is well-trained and trustworthy. The professionalism of J P Home Services really stands out."
    }
  ];

  const benefits = [
    "Trained, verified, and child-friendly babysitters",
    "Flexible timing and duration options",
    "Affordable, transparent pricing",
    "Ongoing support and quick replacements",
    "Trusted by hundreds of families across Gujarat",
    "Available in Ahmedabad, Surat, Vadodara, Rajkot, and Gandhinagar"
  ];

  const cities = [
    "Ahmedabad", "Surat", "Vadodara", "Rajkot", "Gandhinagar", "Anand", "Bhavnagar", "Jamnagar"
  ];
  const handleCall = () => {
    window.open(`tel:${contactConfig.phone}`);
  };

  const handleWhatsApp = () => {
    const phoneNumber = `${contactConfig.phone}`;
    const message = 'Hello, I would like to know more about your services.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };
  const sendEmail = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await emailjs.sendForm(
        "service_v4bj4cq",
        "template_a7bino9",
        form.current,
        "EPURM9NpZ87StWlSC"
      );

      alert("✅ Message sent successfully!");
      e.target.reset();
    } catch (error) {
      console.error("FAILED...", error.text);
      alert("❌ Failed to send message. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="main-content-wrapper">
      <Helmet>
        <title>Book Trusted Baby Sitting in Ahmedabad - JP Home Services</title>
        <meta
          name="description"
          content="JP Home Services offers guaranteed, verified nannies & baby sitting in Ahmedabad. Safe, trusted & caring home baby care. Call q to book."
        />
        <meta
          name="keywords"
          content="Babysitter Services Ahmedabad, Nanny Services Ahmedabad, Baby Care at Home Gujarat, Child Care Services Ahmedabad, Full-time Babysitter, Part-time Babysitter Ahmedabad, Trusted Nanny Gujarat"
        />
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        <link rel="canonical" href="https://jphomeservice.in/baby-sitting-services-in-ahmedabad" />

        {/* Open Graph */}
        <meta property="og:title" content="Book Trusted Baby Sitting in Ahmedabad - JP Home Services" />
        <meta property="og:description" content="JP Home Services offers guaranteed, verified nannies & baby sitting in Ahmedabad. Safe, trusted & caring home baby care. Call to book." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://jphomeservice.in/baby-sitting-services-in-ahmedabad" />
        <meta property="og:site_name" content="JP Home Services" />
        <meta property="og:image" content="https://jphomeservice.in/static/media/babysitting.c98ba7f7e891f0d07ba8.jpeg" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@" />
        <meta name="twitter:title" content="Book Trusted Baby Sitting in Ahmedabad - JP Home Services" />
        <meta name="twitter:description" content="JP Home Services offers guaranteed, verified nannies & baby sitting in Ahmedabad. Safe, trusted & caring home baby care. Call to book." />
        <meta name="twitter:image" content="https://jphomeservice.in/static/media/babysitting.c98ba7f7e891f0d07ba8.jpeg" />

        {/* JSON-LD */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "WebPage",
              "@id": "https://jphomeservice.in/baby-sitting-services-in-ahmedabad#webpage",
              "url": "https://jphomeservice.in/baby-sitting-services-in-ahmedabad",
              "name": "Babysitter & Nanny Services in Ahmedabad - JP Home Services",
              "description": "JP Home Services provides trusted baby sitting in Ahmedabad with trained babysitters & nannies. Safe and caring baby care services at home. Hire now!",
              "inLanguage": "en-IN",
              "isPartOf": {
                "@type": "WebSite",
                "@id": "https://jphomeservice.in/#website",
                "name": "JP Home Services",
                "url": "https://jphomeservice.in/"
              },
              "publisher": {
                "@type": "Organization",
                "@id": "https://jphomeservice.in/#organization",
                "name": "JP Home Services",
                "url": "https://jphomeservice.in/"
              }
            }
          `}
        </script>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "LocalBusiness",
              "name": "Baby Sitting in Ahmedabad",
              "image": "https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png",
              "@id": "",
              "url": "https://jphomeservice.in/baby-sitting-services-in-ahmedabad",
              "telephone": "+919327365056",
              "priceRange": "₹₹",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "A-316-317, Swaminarayan Avenue,  Nr. AEC Cross Road, Naranpura",
                "addressLocality": "Ahmedabad, Gujarat",
                "postalCode": "380013",
                "addressCountry": "IN"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 23.0542109,
                "longitude": 72.5482134
              },
              "openingHoursSpecification": {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": [
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                  "Sunday"
                ],
                "opens": "00:00",
                "closes": "23:59"
              },
              "sameAs": [
                "https://www.facebook.com/jphomeservice.in/",
                "https://www.instagram.com/jp_home_service/"
              ] 
            }
          `}
        </script>
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://jphomeservice.in/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Baby Sitting Services in Ahmedabad",
                "item": "https://jphomeservice.in/baby-sitting-services-in-ahmedabad"
              }
            ]
          }
          `}
        </script>
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Baby Sitting Services in Ahmedabad",
            "serviceType": "Baby Sitting Services",
            "description": "JP Home Service provides baby sitting services in Ahmedabad to help families with reliable childcare support at home.",
            "url": "https://jphomeservice.in/baby-sitting-services-in-ahmedabad",
            "areaServed": {
              "@type": "City",
              "name": "Ahmedabad"
            },
            "provider": {
              "@type": "Organization",
              "name": "JP Home Service",
              "url": "https://jphomeservice.in/"
            }
          }
          `}
        </script>
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Review",
                "@id": "https://jphomeservice.in/baby-sitting-services-in-ahmedabad#review-aarti-patel",
                "url": "https://jphomeservice.in/baby-sitting-services-in-ahmedabad",
                "itemReviewed": {
                  "@type": "Organization",
                  "name": "JP Home Service",
                  "url": "https://jphomeservice.in/"
                },
                "author": {
                  "@type": "Person",
                  "name": "Mrs. Aarti Patel"
                },
                "reviewRating": {
                  "@type": "Rating",
                  "ratingValue": 5,
                  "bestRating": 5,
                  "worstRating": 1
                },
                "reviewBody": "I was nervous about leaving my 6-month-old with anyone, but J P Home Services found us a gentle and caring babysitter who feels like part of our family now."
              },
              {
                "@type": "Review",
                "@id": "https://jphomeservice.in/baby-sitting-services-in-ahmedabad#review-mehta",
                "url": "https://jphomeservice.in/baby-sitting-services-in-ahmedabad",
                "itemReviewed": {
                  "@type": "Organization",
                  "name": "JP Home Service",
                  "url": "https://jphomeservice.in/"
                },
                "author": {
                  "@type": "Person",
                  "name": "Mr. & Mrs. Mehta"
                },
                "reviewRating": {
                  "@type": "Rating",
                  "ratingValue": 5,
                  "bestRating": 5,
                  "worstRating": 1
                },
                "reviewBody": "As working parents, we needed someone reliable. The babysitter from J P Home Services is punctual, responsible, and loves our daughter like her own."
              },
              {
                "@type": "Review",
                "@id": "https://jphomeservice.in/baby-sitting-services-in-ahmedabad#review-niyati-shah",
                "url": "https://jphomeservice.in/baby-sitting-services-in-ahmedabad",
                "itemReviewed": {
                  "@type": "Organization",
                  "name": "JP Home Service",
                  "url": "https://jphomeservice.in/"
                },
                "author": {
                  "@type": "Person",
                  "name": "Dr. Niyati Shah"
                },
                "reviewRating": {
                  "@type": "Rating",
                  "ratingValue": 5,
                  "bestRating": 5,
                  "worstRating": 1
                },
                "reviewBody": "They provided us with a babysitter who is well-trained and trustworthy. The professionalism of J P Home Services really stands out."
              },
              {
                "@type": "AggregateRating",
                "@id": "https://jphomeservice.in/baby-sitting-services-in-ahmedabad#aggregate-rating",
                "itemReviewed": {
                  "@type": "Organization",
                  "name": "JP Home Service",
                  "url": "https://jphomeservice.in/"
                },
                "ratingValue": 5,
                "bestRating": 5,
                "worstRating": 1,
                "reviewCount": 3
              }
            ]
          }
          `}
        </script>
      </Helmet>
      <div className="baby-sitting-container">
        {/* Hero Section */}
        <section className="baby-hero-section">
          <div className="container baby-hero-container">
            <div className="baby-hero-content">
              <h1>Babysitter Services in Ahmedabad, Surat & Major Cities of Gujarat</h1>
              <p><strong>Caring Hands. Trusted Hearts. Reliable Babysitters for Your Little Ones.</strong></p>
              <p>Your child deserves care that feels like family. At J P Home Services, we provide professional babysitter services in Ahmedabad, Surat, Vadodara, Rajkot, and all major cities of Gujarat, ensuring your little ones receive warmth, attention, and protection — even when you're away.</p>
              <p>Our babysitters are trained, verified, and experienced caregivers who understand the emotional and physical needs of children. Whether you're a working parent, have a newborn at home, or need support during events, our babysitters are there to provide safe, loving, and reliable care.</p>
              <div className="hero-stats">
                <div className="stat-item">
                  <span className="stat-number">500+</span>
                  <p className="stat-label">Happy Families</p>
                </div>
                <div className="stat-item">
                  <span className="stat-number">100%</span>
                  <p className="stat-label">Verified Staff</p>
                </div>
                <div className="stat-item">
                  <span className="stat-number">24/7</span>
                  <p className="stat-label">Support</p>
                </div>
              </div>
            </div>
            <div className="baby-hero-image">
              <img
                src={babysitting}
                alt="Happy baby with babysitter"
              />
            </div>
          </div>
        </section>

        {/* Floating Contact Icons */}
        <div className="floating-contact-icons">
          <div className="contact-icon whatsapp-icon" onClick={handleWhatsApp}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893c0-3.18-1.24-6.169-3.495-8.424" />
            </svg>
          </div>
          <div
            className="contact-icon call-icon"
            onClick={handleCall}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 10.999h2C22 5.869 18.127 2 12.99 2v2C17.052 4 20 6.943 20 10.999z" />
              <path d="M13 8c2.103 0 3 .897 3 3h2c0-3.225-1.775-5-5-5v2zm3.422 5.443a1.001 1.001 0 00-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 00.043-1.391L6.859 3.513a1 1 0 00-1.391-.087l-2.17 1.861a1 1 0 00-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 00.648-.291l1.86-2.171a1 1 0 00-.086-1.391l-4.064-3.696z" />
            </svg>
          </div>
        </div>

        {/* Service Features Section */}
        <section className="service-features-section">
          <div className="container">
            <div className="section-header1">
              <h2>Our Babysitter Service Features</h2>
              <p>We handpick only the most reliable, patient, and caring individuals to ensure your children are in safe hands.</p>
            </div>

            <div className="features-grid">
              {serviceFeatures.map((feature, index) => (
                <div key={index} className="feature-item">
                  <div className="feature-icon1">{feature.icon}</div>
                  <span>{feature.text}</span>
                </div>
              ))}
            </div>

            <div className="flexibility-note">
              <p><strong>Choose from part-time, full-time, live-in, or occasional babysitting services</strong> — customized for your family's needs.</p>
            </div>
          </div>
        </section>

        {/* Why Choose Us Section */}
        <section className="why-choose-cook-section">
          <div className="container">
            <div className="section-header1">
              <h2>Why Choose Babysitters from J P Home Services</h2>
              <p>Finding the right babysitter means finding someone you can trust with your most precious one — and that's exactly what we deliver. Here's why families across Gujarat prefer J P Home Services:</p>
            </div>

            <div className="features-grid">
              {whyChooseUs.map((feature, index) => (
                <div key={index} className="feature-card">
                  <div className="feature-icon1">{feature.icon}</div>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              ))}
            </div>

            <div className="additional-benefits">
              <div className="benefit-item">
                <span className="check-icon">✓</span>
                <span>Emergency Preparedness - Our staff are trained in basic first aid and know how to respond calmly in critical situations</span>
              </div>
              <div className="benefit-item">
                <span className="check-icon">✓</span>
                <span>Replacement Assurance - Quick replacements in case you wish to change your babysitter without additional cost</span>
              </div>
            </div>

            <div className="trust-note">
              <p><strong>Your child's comfort and safety are our highest priority.</strong></p>
            </div>
          </div>
        </section>

        {/* How It Works Section */}
        <section className="process-section">
          <div className="container">
            <div className="section-header1">
              <h2>How Our Babysitter Service Works</h2>
              <p>Hiring a babysitter through J P Home Services is simple, secure, and transparent.</p>
            </div>

            <div className="process-steps">
              {processSteps.map((step, index) => (
                <div key={index} className="process-step">
                  <div className="step-number">{step.step}</div>
                  <div className="step-content">
                    <h3>{step.title}</h3>
                    <p>{step.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="process-conclusion">
              <p><strong>From first contact to ongoing care — we make it effortless.</strong></p>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="baby-features-section">
          <div className="container">
            <h2>Our Professional Babysitting Services</h2>
            <div className="features-grid">
              {babySittingFeatures.map((feature, index) => (
                <div key={index} className="feature-card">
                  <div className="feature-icon1">{feature.icon}</div>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Booking Form Section */}
        <section className="booking-section">
          <div className="container">
            <div className="booking-content">
              <div className="booking-info">
                <h2>Book a Babysitter</h2>
                <p>Fill out the form and we'll match you with the perfect babysitter for your child's needs.</p>

                <div className="service-highlights">
                  <div className="highlight-item">
                    <span className="highlight-icon">✅</span>
                    <span>Background verified and police checked</span>
                  </div>
                  <div className="highlight-item">
                    <span className="highlight-icon">✅</span>
                    <span>First-aid trained professionals</span>
                  </div>
                  <div className="highlight-item">
                    <span className="highlight-icon">✅</span>
                    <span>Flexible scheduling options</span>
                  </div>
                  <div className="highlight-item">
                    <span className="highlight-icon">✅</span>
                    <span>Quick replacement guarantee</span>
                  </div>
                </div>

                <div className="contact-info">
                  <h3>Need Immediate Help?</h3>
                  <p>Call us: <strong>{contactConfig.phone}</strong></p>
                  <p>Email: <strong>{contactConfig.email}</strong></p>
                </div>
              </div>

              <div className="booking-form-container">
                <form
                  className="contact-form"
                  ref={form}
                  onSubmit={sendEmail}
                >
                  <div className="form-group123">
                    <h3>Request Baby Sitting Service</h3>
                  </div>
                  {/* <div className="form-group">
                      <label htmlFor="location">Maid in Ahmedabad</label>
                    </div> */}

                  <div className="form-group">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      placeholder="Your Name*"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="email"
                      id="email"
                      name="emailid"
                      placeholder="Email Address*"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="tel"
                      id="phone"
                      name="contactno"
                      placeholder="Phone Number*"
                      required
                    />
                  </div>


                  <div className="form-row">
                    <div className="form-group">
                      <select id="category" required name="ServiceRequired">
                        <option value="">Choose a category</option>
                        <option value="House Maid">House Maid</option>
                        <option value="Baby Sitting">Baby Sitting</option>
                        <option value="Elderly Care">Elderly Care</option>
                        <option value="Patient Care">Patient Care</option>
                        <option value="Cook">Cook</option>
                        <option value="Driver">Driver</option>
                        <option value="Full Time Servant">
                          24x7 Servant
                        </option>
                        <option value="Office Boy">Office Boy</option>
                        <option value="Pet Care">Pet Care</option>
                      </select>
                    </div>
                  </div>

                  {/* <div className="form-group">
                      <textarea
                        id="message"
                        placeholder="Your Message*"
                        rows="5"
                        name="user_message"
                        required
                      ></textarea>
                    </div> */}

                  <button
                    type="submit"
                    className="submit-btn1"
                    disabled={loading}
                    onClick={() => {
                      return window.gtag_report_conversion
                        ? window.gtag_report_conversion("https://jphomeservice.in/")
                        : true;
                    }}
                  >
                    {loading ? "Sending..." : "Send Message"}
                  </button>

                </form>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="testimonials-section">
          <div className="container2">
            <h2>What Parents Say About Us</h2>
            <div className="testimonials-grid">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="testimonial-card">
                  <div className="testimonial-rating">{testimonial.rating}</div>
                  <p className="testimonial-text">"{testimonial.text}"</p>
                  <div className="testimonial-author">
                    <strong>{testimonial.name}</strong>
                    <span>{testimonial.location}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="benefits-section">
          <div className="container">
            <div className="section-header1">
              <h2>Benefits of Choosing J P Home Services for Babysitter Needs</h2>
              <p>Choosing the right babysitter means peace of mind — and that's what J P Home Services guarantees.</p>
            </div>

            <div className="benefits-grid">
              {benefits.map((benefit, index) => (
                <div key={index} className="benefit-item-large">
                  <span className="check-icon">✓</span>
                  <span>{benefit}</span>
                </div>
              ))}
            </div>

            <div className="brand-tagline">
              <p><strong>Because when it comes to your child, only the best care will do.</strong></p>
            </div>
          </div>
        </section>

        {/* Service Coverage Section */}
        <section className="coverage-section">
          <div className="container">
            <div className="section-header1">
              <h2>Service Coverage</h2>
              <p>Our professional babysitter services are available in:</p>
            </div>

            <div className="cities-grid">
              {cities.map((city, index) => (
                <div key={index} className="city-item">
                  {city}
                </div>
              ))}
            </div>

            <div className="coverage-note">
              <p><strong>Whether you need part-time help for a few hours or full-time care, J P Home Services ensures your child receives love and care in your absence.</strong></p>
            </div>
          </div>
        </section>

        {/* <Contact/> */}
      </div>
    </div>
  );
}